// removed by extract-text-webpack-plugin
module.exports = {"companyCell":"_4PrMDejVoEVt3Yq1cb1tV","logo":"_1EHbv7CNXdNhFYBYj3JJhK","about":"_3y1-SuaNODXb75PsZnLD1k","title":"f3lFPk9gRU0x1zeG9AfJj","defaultLang":"rsPp3WpG00UNUSXNPrLIS","description":"_1k13UZdPujYZygy1IeMpr0","moreInfo":"_1hlFqondJHQofwRAHRB94u","countFlag":"fPOca6WrFzcXRzt-GcyKa","label":"_3egoyExWHLa0kUFobYxRSX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyCellDesktop/CompanyCellDesktop.scss
// module id = 1558
// module chunks = 0